import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-scrollable.css';

const EGDSScrollableTags = [
    'div',
    'article',
    'aside',
    'footer',
    'header',
    'section',
    'ul',
    'ol',
    'li',
    'main',
];

const getClassNameList = classNames.bind(styles);
const EGDSScrollable = (props) => {
    const { tag, direction = 'horizontal', tabbable = true, className, children } = props;
    const baseCssClass = 'uitk-scrollable';
    const cssClassNames = getClassNameList(className, baseCssClass, `${baseCssClass}-${direction}`);
    const scrollableRef = React.useRef(null);
    const [mouseStartPos, setMouseStartPos] = React.useState(0);
    const [scrollStartPos, setScrollStartPos] = React.useState(0);
    const [isDragging, setIsDragging] = React.useState(false);
    const handleMouseDown = (e) => {
        setIsDragging(true);
        scrollableRef.current && setScrollStartPos(scrollableRef.current.scrollLeft);
        setMouseStartPos(e.pageX);
    };
    const handleMouseEnter = (e) => {
        if (isDragging)
            handleMouseDown(e);
    };
    const handleMouseUp = () => setIsDragging(false);
    const handleMouseMove = (e) => {
        if (isDragging && scrollableRef.current)
            scrollableRef.current.scrollLeft = scrollStartPos - (e.pageX - mouseStartPos);
    };
    React.useEffect(() => {
        if (isDragging)
            document.addEventListener('mouseup', handleMouseUp);
        return () => document.removeEventListener('mouseup', handleMouseUp);
    }, [isDragging]);
    let horizontalProps;
    if (direction === 'horizontal') {
        horizontalProps = {
            onMouseEnter: handleMouseEnter,
            onMouseMove: handleMouseMove,
            onMouseDown: handleMouseDown,
            ref: scrollableRef,
        };
    }
    // Renders the custom Tag
    const Tag = tag && EGDSScrollableTags.includes(tag) ? tag : 'div';
    return (jsx(Tag, { tabIndex: tabbable ? 0 : -1, role: "group", className: cssClassNames, ...horizontalProps, children: children }));
};
EGDSScrollable.displayName = 'EGDSScrollable';

export { EGDSScrollable as E };
//# sourceMappingURL=index-chunk.esm.js.map
